/** A financial total is complete only when every contributing amount is known.
 * Empty input and explicit zero remain zero; partial sums must not look final. */
export function sumKnownMoney(
  values: Iterable<number | null | undefined>,
): number | null {
  let total = 0
  for (const value of values) {
    if (value == null || !Number.isFinite(value)) return null
    total += value
  }
  return Number.isFinite(total) ? total : null
}
